import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { SonarMenuItem } from '@ui/menu';

export const helpMenuItem: SonarMenuItem = {
	icon: <QuestionCircleOutlined />,
	id: 'help-menu-item',
	key: 'Support',
	label:
	<>
		<a
			href='https://sonarsoftware.zendesk.com/hc/en-us/'
			target='_blank' />
		<span>{ COPY_SPECIFIC.SUPPORT }</span>
	</>

};
